import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceMediaComponent } from './price-media.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { PageTitle } from '../store-front/misc/page-title/page-title.component';
import { PriceMediaRequestComponent } from './components/price-media-request/price-media-request.component';
import { PriceMediaHistoryComponent } from './components/price-media-history/price-media-history.component';
import { TabOptionsComponent } from '../../../components/tab-options/tab-options.component';
import { DatePickerModule } from 'primeng/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { LocalLoaderComponent } from '../../../components/loader/local-loader/local-loader.component';
import { FormModule } from '@spartacus/organization/administration/components';
import { RouterModule } from '@angular/router';
import { FormErrorsModule } from '@spartacus/storefront';
import { TableProComponent } from '../../../components/table-pro/table-pro.component';
import { priceMediasOccConfig } from './core/price-media.occ';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [PriceMediaComponent, PriceMediaRequestComponent, PriceMediaHistoryComponent],
  imports: [
    CommonModule,
    PageTitle,
    I18nModule,
    FormModule,
    RouterModule,
    FormErrorsModule,
    DatePickerModule,
    ReactiveFormsModule,
    TableProComponent,
    TabOptionsComponent,
    ReactiveFormsModule,
    LocalLoaderComponent,
    TooltipModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        PriceMediaPageComponent: {
          component: PriceMediaComponent,
        },
      },
    }),
    provideConfig(priceMediasOccConfig),
    provideConfig({
      routing: {
        routes: {
          priceMediaPage: { paths: ['my-account/price-media'] },
        },
      },
    }),
  ],
})
export class PriceMediaModule {}
